export default __webpack_public_path__ + "static/media/ecosystem-members-link-img2.078a5cc4.png";